import { render, staticRenderFns } from "./ModelosTabela.vue?vue&type=template&id=7410ecda"
import script from "./ModelosTabela.vue?vue&type=script&lang=js"
export * from "./ModelosTabela.vue?vue&type=script&lang=js"
import style0 from "./ModelosTabela.vue?vue&type=style&index=0&id=7410ecda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports